import { useSelector } from "react-redux";



function FrontendVersion(
) {

  return (
    <>
      <div style={{ display: 'none' }}>
        2025-11-20-01
      </div>
    </>
  );
}

export default FrontendVersion;
